export default __webpack_public_path__ + "static/media/graph-up.b5c659f9.svg";